import { SVGProps } from "react";

import { cn } from "../lib/cn";

/**
 * An indeterminate loading ring in the text color. It's decorative, so pair it
 * with visible text that says what's loading.
 */
export const Spinner = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
    className={cn("size-6 animate-spin motion-reduce:animate-none", className)}
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeOpacity={0.2}
      strokeWidth={2.5}
    />
    <path
      d="M22 12a10 10 0 0 0-10-10"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
    />
  </svg>
);
